import http from "@/settings/apiSettings"

class MeseriiDataService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/PER_Meserii", data)
    }
}
export default new MeseriiDataService()